<template>
  <a target="_blank" :class="type">
    <i :class="left_icon"></i>
    <slot/>
    <i :class="right_icon"></i>
  </a>
</template>

<script>

  export default {
    name: 'lte-hyperlink',
    props: [ 'type','left_icon','right_icon'],
    methods: {     
    },
  }

</script>

<style lang="scss" scoped>    
  a {
    color: #5A738E;
    text-decoration: none; 
  }
</style>


// WEBPACK FOOTER //
// src/components/LTEHyperlink.vue